/**
 * @fileoverview AppPortalNavigation — left rail of categories inside
 * AppPortalDialog. A wrapper around AppPortalNavigationItem rows and
 * AppPortalCategoryHeader section headings.
 *
 * THE CLASS IS LOAD-BEARING FOR ITS CHILDREN, not for this element. Foundry
 * styles the rail's section headings as
 * `.__navigation__1iafdj1 .__header__1iafdj1` — uppercase, 12px/16px — so
 * without the class here the headings inherit body type and read as ordinary
 * text. `__navigation__1iafdj1` has no rule of its own, which is exactly why it
 * was easy to leave off.
 *
 * A `nav`, where Foundry uses a `div`. That is deliberate: the computed styles
 * are identical, and the landmark plus its label are what let a screen reader
 * skip the rail. Matching the tag would trade a real affordance for a
 * difference nobody can see.
 */

import type { ReactNode } from "react";
import { applicationPortalDialog as fdy } from "./foundry-parts.generated";

interface AppPortalNavigationProps {
  children: ReactNode;
  className?: string;
}

export function AppPortalNavigation({ children, className }: AppPortalNavigationProps) {
  return (
    <nav data-testid="app-portal-navigation"
      className={[fdy["navigation"], "bp-app-portal-navigation", className]
        .filter(Boolean)
        .join(" ")}
      aria-label="App categories"
    >
      {children}
    </nav>
  );
}
